module.exports = __webpack_public_path__ + "static/media/Transfer.b2328beb.less";


//////////////////
// WEBPACK FOOTER
// ./src/components/Transfer/Transfer.less
// module id = 114
// module chunks = 0